import { useCallback, useEffect, useState } from "react";
import { StoredBeauftragungPreviewDialog } from "@/components/beauftragung/StoredBeauftragungPreviewDialog";
import {
  fetchTagesgeschaeftBeauftragung,
  listAuftragMailBeauftragungen,
  type StoredMailBeauftragung,
} from "@/lib/tagesgeschaeft";

function fmtDateTime(value: string | null | undefined): string {
  if (!value) return "";
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleString("de-DE", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
}

/** Beauftragungen, bei denen nur die Mail (oder ihr Text) im Projekt liegt. */
export function StoredMailBeauftragungen({ orderId }: { orderId: number }) {
  const [items, setItems] = useState<StoredMailBeauftragung[]>([]);
  const [openId, setOpenId] = useState<number | null>(null);

  useEffect(() => {
    let cancelled = false;
    void listAuftragMailBeauftragungen(orderId)
      .then((rows) => {
        if (!cancelled) setItems(rows);
      })
      .catch(() => {
        if (!cancelled) setItems([]);
      });
    return () => {
      cancelled = true;
    };
  }, [orderId]);

  const active = items.find((item) => item.id === openId) ?? null;
  const load = useCallback(() => {
    if (openId == null) return Promise.reject(new Error("Keine Beauftragung ausgewählt."));
    return fetchTagesgeschaeftBeauftragung(openId);
  }, [openId]);

  if (!items.length) return null;

  return (
    <>
      <ul className="eh-po-timesheet-list mb-3">
        {items.map((item) => {
          const when = fmtDateTime(item.confirmed_at);
          const from = [item.from_name, item.from_email].filter(Boolean).join(" · ");
          return (
            <li key={item.id} className="eh-po-timesheet-row">
              <div className="eh-po-timesheet-meta">
                <div className="eh-po-timesheet-title">Beauftragung</div>
                <div className="eh-po-timesheet-subtitle">
                  {[item.subject || item.filename, from, when].filter(Boolean).join(" · ") || "Mail"}
                </div>
              </div>
              <div className="eh-po-timesheet-actions">
                <button
                  type="button"
                  className="eh-po-timesheet-action eh-po-timesheet-action--primary"
                  onClick={() => setOpenId(item.id)}
                >
                  Ansehen
                </button>
              </div>
            </li>
          );
        })}
      </ul>
      <StoredBeauftragungPreviewDialog
        open={active != null}
        title={active?.subject || active?.filename || "Beauftragung"}
        description={active?.filename}
        load={load}
        onClose={() => setOpenId(null)}
      />
    </>
  );
}
